import { createVanIconComponent } from "./van"

const Checked = createVanIconComponent("checked")
export default Checked
